export const TEXT_COLOR_TYPE = 'wix-rich-content-text-color';
export const TEXT_HIGHLIGHT_TYPE = 'wix-rich-content-text-highlight';
